/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2636__part-34
 */

"use strict"

import * as /* [auto-meaningful-name] */Module_60 from /* 60 */"./60"
import * as /* [auto-meaningful-name] */Src_editor_ui_PreviewArea_WidgetList_styles_module_css from /* 196 */"../../../../src/editor/ui/PreviewArea/WidgetList/styles.module.css"
import /* [auto-meaningful-name] */Src_editor_ui_PreviewArea_WidgetList_styles_module_css1 from /* 196 */"../../../../src/editor/ui/PreviewArea/WidgetList/styles.module.css"
import * as /* [auto-meaningful-name] */Module_146 from /* 146 */"./146"
var Xd = [
  {
    type: "WidgetTitle",
    hasDisableOrVisible: true
  }, {
    type: "VisibleSwitch"
  }, {
    type: "TextWidgetTextGroup"
  }, {
    type: "BackgroundColor"
  }, {
    type: "AntSwitch",
    label: "textOverflow",
    key: "overflow",
    convert: function (e) {
      return undefined === e || "hidden" === e
    },
    reverse: function (e) {
      return e ? "hidden" : "visible"
    }
  }, {
    type: "Align"
  }, {
    type: "WidgetOpacity"
  }, {
    type: "Size",
    sizeRange: [[Module_146.m, Module_60.l], [Module_146.l, Module_60.g]]
  }, {
    type: "Coordinate"
  }
]
var Qd = [
  {
    type: "WidgetTitle",
    hasDisableOrVisible: true
  }, {
    type: "VisibleSwitch"
  }, {
    type: "TextArea"
  }, {
    type: "FontFamily"
  }, [
    {
      type: "Color",
      label: "textColor"
    }, {
      type: "BackgroundColor"
    }
  ], {
    type: "HorizontalAlign"
  }
]
export { Xd }
export { Qd }
